new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },
        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },
        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },
        checkBuyView() {
            const buyButton = document.querySelector("#buy-button .wrapper-buttons");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },
        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },
        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    created() {
        const label = document.querySelector('.product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }
    },
    mounted() {
        this.resizeThumbs();
        this.clickThumbs();

        this.checkBuyView();
        window.addEventListener("scroll", this.checkBuyView, { passive: true });


        let navTab = document.querySelector('.product-detail__nav');
        if (navTab) {
            let navItem = navTab.querySelectorAll('.nav-item');
            navItem.forEach((item) => {
                let navShow = item.querySelector('.product-detail__nav-content');
                let itemOpen = item.querySelector('.nav-item-open');
                let sidebarInner = document.querySelector('.product-detail__header--infoArea .sidebar__inner');
                let infoArea = document.querySelector('.product-detail__header--infoArea');
                itemOpen.addEventListener('click', () => {
                    navShow.classList.toggle('active');
                    itemOpen.classList.toggle('active');
                    if (sidebarInner && infoArea) {
                        let sidebarHeight = sidebarInner.getBoundingClientRect().height;
                        let childToParentDistance = sidebarInner.offsetTop;
                        infoArea.style.height = (childToParentDistance + sidebarHeight) + 'px';
                    }
                })
            })
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }



        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });




    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    waitForElementToExist('#add-together__template').then(element => {
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class' &&
                    mutation.target.matches('.product-item.need-select') &&
                    !mutation.oldValue?.split(/\s+/).includes('need-select')
                ) {
                    mutation.target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });

                    break;
                }
            }
        });

        observer.observe(element, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
            attributeOldValue: true
        });
    });

    const haveKit = document.querySelector('.carousel-kit');
    if (haveKit) {
        (function () {
            document.addEventListener('click', function (event) {
                const colorItem = event.target.closest('.product__colors-item');
                if (!colorItem) return;

                const id = colorItem.dataset.id;
                if (!id) return;

                getInfo(event, id);
            });

            function getInfo(event, id) {
                axios.get(`/api/front/product/${id}/get-linked-product/`)
                    .then(res => {
                        const actualElement = event.target;

                        if (
                            $('.kitcolors')
                                .closest('.js_product_item_kit')
                                .siblings('.js-product_addons__product_detail_kit')
                                .length
                        ) {
                            $('.kitcolors')
                                .closest('.js_product_item_kit')
                                .siblings('.js-product_addons__product_detail_kit')
                                .remove();
                        }

                        const productItemKit = actualElement.closest('.product-item-kit');

                        productItemKit.querySelector('.is-selected')?.classList.remove('is-selected');
                        actualElement.closest('.product__colors-item').classList.add('is-selected');

                        productItemKit.setAttribute(
                            'data-product-item-kit-id',
                            res.data.id
                        );

                        productItemKit.querySelector('.name span').innerHTML = res.data.name;
                        productItemKit.querySelector('.name img').src = res.data.thumbnail;

                        const actualVariations = productItemKit.nextElementSibling;
                        actualVariations.innerHTML =
                            '<p class="label_attributes">Selecione o tamanho</p>';

                        let sizes = [];

                        for (let i = 0; i < res.data.variations.length; i++) {
                            const variation = res.data.variations[i];
                            if (variation.main_attribute) {
                                sizes.splice(
                                    variation.main_attribute.order,
                                    0,
                                    variation
                                );
                            }
                        }

                        for (let i = 0; i < sizes.length; i++) {
                            const size = sizes[i];
                            if (!size.main_attribute) continue;

                            const randomNumber = Math.floor(Math.random() * 99999999);
                            const stock = size.available === false ? 'out-of-stock' : '';

                            actualVariations.insertAdjacentHTML(
                                'beforeend',
                                `
                        <input
                            type="radio"
                            name="product_item_variation__product_detail__${res.data.id}_${randomNumber}"
                            id="product_item_variation__product_detail__${size.id}_${randomNumber}"
                            value="${size.id}"
                            data-variation-name="${size.main_attribute.name}"
                        >
                        <label
                            for="product_item_variation__product_detail__${size.id}_${randomNumber}"
                            class="label_radio ${stock} radio"
                        >
                            <span>${size.main_attribute.value}</span>
                        </label>
                        `
                            );
                        }

                        if (res.data.addons.length) {
                            const complements = document.createElement('div');
                            complements.id = `js-product_addons__product_detail_${id}`;
                            complements.className = 'complements';
                            complements.setAttribute('complements-for', id);
                            complements.innerHTML =
                                '<h2 class="complements-title">Complementos:</h2><br>';

                            for (let i = 0; i < res.data.addons.length; i++) {
                                const addon = res.data.addons[i];
                                const optional = addon.is_required ? 'False' : 'True';
                                const addonPrice = addon.price || '';

                                complements.insertAdjacentHTML(
                                    'beforeend',
                                    `
                            <label
                                class="complements-label-${addon.id}"
                                addon-id="${addon.id}"
                                addon-price="${addonPrice}"
                                data-addon-is-optional="${optional}"
                            >
                                ${addon.field_label}
                            </label>
                            `
                                );

                                if (addon.field_type === 'radio_options') {
                                    const select = document.createElement('select');
                                    select.name = `addon-${addon.id}`;
                                    select.id = `addon-select-${addon.id}`;

                                    addon.field_options.forEach(opt => {
                                        select.add(new Option(opt, opt));
                                    });

                                    const div = document.createElement('div');
                                    div.className = 'complements-content';
                                    div.appendChild(select);
                                    complements.appendChild(div);
                                }

                                if (addon.field_type === 'text') {
                                    const div = document.createElement('div');
                                    div.className = 'complements-content-area';
                                    div.innerHTML = `
                                <input
                                    name="addon-${addon.id}"
                                    type="text"
                                    maxlength="${addon.field_char_limit}"
                                >
                            `;
                                    complements.appendChild(div);
                                }
                            }

                            $('.kitcolors')
                                .closest('.itens-for-carousel')
                                .append(complements);
                        }

                        $('.kitcolors').height(
                            $('.kitcolors')
                                .closest('.itens-for-carousel')
                                .outerHeight()
                        );

                        $(productItemKit)
                            .siblings('.product-radio-variation')
                            .find('input')
                            .on('change', function () {
                                $(this)
                                    .siblings('input')
                                    .not(this)
                                    .prop('checked', false);
                            });
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        })();
    }

    const allSizesLabel = document.querySelectorAll('label[for^="product_item_variation__product_detail__');
    if (allSizesLabel) {
        allSizesLabel.forEach(label => {
            label.addEventListener('click', () => {
                const inputId = label.getAttribute('for');
                if (inputId) {
                    const container = document.querySelector('.product-detail__fixed--buy');
                    if (container) {
                        const inputsInContainer = container.querySelectorAll('input.clicou');
                        inputsInContainer.forEach(input => {
                            input.classList.remove('clicou');
                        });
                    }

                    const allInputs = document.querySelectorAll(`input[id^="${inputId}"]`);

                    if (allInputs) {
                        allInputs.forEach(input => {
                            input.classList.add('clicou');
                        })
                    }

                }
            });
        })
    }

    const aboutThemes = document.querySelector('.duvidas');
    if (aboutThemes) {
        const duvidasItem = document.querySelectorAll('.duvidas-list li');
        if (duvidasItem.length) {
            duvidasItem.forEach((item) => {
                item.addEventListener('click', (e) => {
                    item.classList.toggle('active');
                });
            });
        }
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            const sidebarInner = document.querySelector('.sidebar__inner');

            if (photoScroll && sidebarInner && photoScroll.offsetHeight > sidebarInner.offsetHeight) {
                const containerWidth = $('.product-detail__header--infoArea').width();
                const sidebarInnerHeight = sidebarInner.offsetHeight;
                const totalHeight = photoScroll.offsetHeight - sidebarInnerHeight;
                const pageTop = window.pageYOffset;
                const rect = photoScroll.getBoundingClientRect();
                const offsetTop = rect.top + pageTop; // Calculate the distance from top of the page to the photoScroll

                if (pageTop > (offsetTop + totalHeight)) {
                    $('.sidebar__inner').css({ position: 'relative', top: totalHeight + 'px', maxWidth: '100%' });
                } else if (pageTop > offsetTop) {
                    $('.sidebar__inner').css({ position: 'fixed', top: '0px', maxWidth: containerWidth + 'px' });
                } else {
                    $('.sidebar__inner').css({ position: 'relative', top: '0px', maxWidth: '100%' });
                }
            }
        }

        window.addEventListener('scroll', function () {
            animeScroll();
        });

        animeScroll();
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    if ($('.product-photo-background')) {
        $('.product-photo-background').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                    }
                },
            ]
        });
    }

    // waitForElementToExist('.faixa-comunicado').then(element => {
    //     const banner = element.querySelector('#faixa-comunicado');

    //     if (banner) {
    //         $('.faixa-comunicado__content').slick({
    //             arrows: false,
    //             dots: true,
    //             infinite: true,
    //             mobileFirst: true,
    //             autoplay: true,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             speed: 700,
    //         });
    //     }
    // });

    if ($('.product-detail__header--photoArea-mobile')) {
        $('.product-detail__header--photoArea-mobile').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    let navTab = document.querySelector('.product-detail__nav');
    let nav = document.querySelector('.product-detail__nav-tab');
    let navItem = nav ? nav.querySelectorAll('.nav-item') : [];
    let navContent = document.querySelector('.product-detail__nav-content');
    let navShow = navContent ? navContent.querySelectorAll('.nav-show') : [];

    if (navTab && navItem.length && navShow.length) {
        navItem = Array.from(navItem);
        navShow = Array.from(navShow);

        navItem[0].classList.add('active');
        navShow[0].classList.add('active');

        function activeTab(index) {
            navShow.forEach((content) => {
                content.classList.remove('active');
            });
            navShow[index].classList.add('active');
        }

        navItem.forEach((itemMenu, index) => {
            itemMenu.addEventListener('click', () => {
                activeTab(index);
                navItem.forEach((item) => {
                    item.classList.remove('active'); // Adicionado para remover a classe 'active' dos outros itens
                });
                itemMenu.classList.add('active'); // Adicionado para adicionar a classe 'active' ao item clicado
            });
        });
    }

    const toggleErpDescrip = document.querySelectorAll('.toggle-description');
    if (toggleErpDescrip.length > 0) {
        toggleErpDescrip.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const wrapper = btn.closest('.description-wrapper');
                const shortDesc = wrapper.querySelector('.description-short');
                const fullDesc = wrapper.querySelector('.description-full');

                const isExpanded = fullDesc.style.display === 'block';

                shortDesc.style.display = isExpanded ? 'block' : 'none';
                fullDesc.style.display = isExpanded ? 'none' : 'block';
                btn.textContent = isExpanded ? 'Ver mais' : 'Ver menos';
            });
        });
    }

    if ($('#like-carousel')) {
        $('#like-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: true,
            prevArrow: $(".count .count-prev"),
            nextArrow: $(".count .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }



    const ratings = document.querySelector('.rating-assessment');
    if (ratings) {
        $('.product-rating__review-list').slick({
            arrows: true,
            appendArrows: $('.product-detail__rating-left .count'),
            infinite: false,
            autoplay: false,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        });
    }

    $('#photo-fancy').fancybox();

    const buyTogether = document.querySelector('.product-detail__buy-together');

    if (buyTogether) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                    if (options) {
                                        options.classList.toggle('frente');
                                    }
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        if (options) {
                                            options.classList.toggle('frente');
                                        }
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('div[id^="js-product_price__product_detail_list_"]');

                            if (options && figcaption) {
                                figcaption.insertAdjacentElement('afterend', options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            } else if (!sizes && widget) {
                                widget.classList.add('no-before')
                            }
                        }
                    }
                });
            });
        });

        observer.observe(buyTogether, {
            childList: true,
            subtree: true
        });

    }

    // Atualiza .label_attributes_text ao clicar em labels dentro de .product-radio-variation
    document.addEventListener('click', function (e) {
        const clickedLabel = e.target.closest('.product-radio-variation label');
        if (!clickedLabel) return;
        const variationContainer = clickedLabel.closest('.product-radio-variation');
        if (!variationContainer) return;
        const targetLabelText = variationContainer.querySelector('.label_attributes_text');
        if (!targetLabelText) return;
        const valueWithoutSpaces = clickedLabel.textContent.replace(/\s+/g, '');

        // Guarda o texto original do admin na primeira vez
        if (!targetLabelText.hasAttribute('data-original-text')) {
            const selectedEl = targetLabelText.querySelector('.js-selected-variation-text');
            if (selectedEl) {
                // Se já tem um span, remove ele para pegar apenas o texto original
                selectedEl.remove();
            }
            targetLabelText.setAttribute('data-original-text', targetLabelText.textContent.trim());
        }

        const originalText = targetLabelText.getAttribute('data-original-text');
        const selectedEl = targetLabelText.querySelector('.js-selected-variation-text');

        if (selectedEl) {
            // Remove o span anterior
            selectedEl.remove();
        }

        // Restaura o texto original do admin
        targetLabelText.textContent = originalText;

        // Adiciona o novo valor após dois pontos
        const newSelectedEl = document.createElement('span');
        newSelectedEl.className = 'js-selected-variation-text';
        newSelectedEl.textContent = ': ' + valueWithoutSpaces;
        targetLabelText.appendChild(newSelectedEl);
    }, { passive: true });

    // Observer para clonar #js-product_price__product_detail_ de .product-detail__header--infoArea ou .product-detail__header--mobile-info para .product-detail__fixed--buy
    let priceObserver = null;

    function setupPriceObserver() {
        // Desconecta o observer anterior se existir
        if (priceObserver) {
            priceObserver.disconnect();
            priceObserver = null;
        }

        const isMobile = window.matchMedia('(max-width: 991px)').matches;
        let container, groupRef;

        if (isMobile) {
            container = document.querySelector('.product-detail__header--mobile-info');
        } else {
            container = document.querySelector('.product-detail__header--infoArea');
        }

        if (!container) return;

        groupRef = container.querySelector('.group-ref');
        if (!groupRef) return;

        priceObserver = new MutationObserver(function (mutations) {
            // Busca o elemento de preço dentro do .group-ref
            const sourcePriceElement = groupRef.querySelector('div[id^="js-product_price__product_detail_"]');
            if (!sourcePriceElement) return;

            // Pega o elemento de destino dentro de .product-detail__fixed--buy
            const targetFixedBuy = document.querySelector('.product-detail__fixed--buy');
            if (!targetFixedBuy) return;

            const targetPriceElement = targetFixedBuy.querySelector('div[id^="js-product_price__product_detail_"]');
            if (!targetPriceElement) return;

            // Clona a tag inteira incluindo todos os atributos
            const clonedElement = sourcePriceElement.cloneNode(true);

            // Substitui o elemento de destino pelo clone
            targetPriceElement.parentNode.replaceChild(clonedElement, targetPriceElement);
        });

        // Observa mudanças no .group-ref e em seus filhos
        priceObserver.observe(groupRef, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }

    // Configura o observer inicial
    setupPriceObserver();

    // Reconfigura o observer quando o tamanho da tela mudar
    const mediaQuery = window.matchMedia('(max-width: 991px)');
    mediaQuery.addEventListener('change', function () {
        setupPriceObserver();
    });

})